import { Exclude, Expose } from '../serialization/class-transformer/decorators';
import { ServiceRequest } from './service-request';

@Exclude()
export class GenericArrayServiceRequest<TRequestData> extends ServiceRequest {

    @Expose()
    requestData: TRequestData[];
}
